module.exports = __webpack_public_path__ + "img/detail2.62bc4fe7.png";